import { UnlockKeyhole } from '@styled-icons/fa-solid/UnlockKeyhole';
import { Rocket } from '@styled-icons/ionicons-sharp';
import { Science } from '@styled-icons/material-rounded/Science';
import { SearchEye } from '@styled-icons/remix-fill';

type Value = {
  title: string;
  description: string;
  icon: keyof typeof valuesIcons;
};

export const values: Array<Value> = [
  {
    title: 'Innovazione e tecnologia',
    description:
      'Crediamo che la tecnologia possa dare un enorme contributo nel rendere più agile la relazione medico-paziente. Innovare per noi è anticipare bisogni, fornendo delle soluzioni nuove ai problemi di sempre.',
    icon: 'innovazione',
  },
  {
    title: 'Affidabilità scientifica',
    description:
      'Un lavoro continuo di validazione scientifica e clinica ci permette di fornire  indicazioni affidabili e di porci come un punto di riferimento nella relazione medico-paziente.',
    icon: 'affidabilita_scientifica',
  },
  {
    title: 'Accessibilità',
    description:
      'Il nostro mantra quotidiano è rendere semplice e accessibile la salute, soprattutto nei temi quotidiani e di prevenzione.',
    icon: 'accessibilita',
  },
  {
    title: 'Trasparenza',
    description:
      'Per noi significa chiarezza nella  comunicazione con i pazienti e nella gestione delle informazioni che li riguardano, ma anche sincerità nella relazione con ognuno dei  nostri stakeholder.',
    icon: 'transparenza',
  },
];

export const valuesIcons = {
  innovazione: Rocket,
  affidabilita_scientifica: Science,
  accessibilita: UnlockKeyhole,
  transparenza: SearchEye,
};
